import { cloneDeep } from 'lodash';
import { CompositeModel } from '../models/complex/composite.model';
import { ModelOptions } from '../models/options/model-options';
import { PrimitiveModel } from '../models/primitive/primitive.model';
import { isDefined } from './is-defined';
import { ArrayModel } from '../models/complex/array.model';

// function to be used, when needing to trigger a change detection on the model options, after the model has been created
// do not use this function in the constructor of models, as it can be very time-consuming and would lead to performance issues
// if the model has a lot of entries as dependencies.
export const assignModelOptions = <T extends PrimitiveModel | ArrayModel<PrimitiveModel>>(
    model: T,
    options: ModelOptions,
    parentModel?: CompositeModel,
): T => {
    const newModel = cloneDeep(model);

    newModel.options = { ...options };

    if (isDefined(parentModel) && parentModel.value[model.name]) {
        parentModel.set(newModel);
    }

    return newModel;
};
